module.exports = __webpack_public_path__ + "img/1528909177.916e4e9f.jpg";